import { MixpanelTracker } from './vendors/mixpanelTracker';
// create and export a singleton of the tracker:
const tracker = new MixpanelTracker();
export default tracker;
